// import React, { useContext } from 'react';
// import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
// import { CardsProvider, CardsContext } from './context/CardsContext';
// import Main from './pages/Main';
// import Adventures from './pages/Adventures';
// import Study from './pages/Study';
// import Races from './pages/Races';
// import Info from './pages/Info';
// import Schedule from './pages/Schedule';
// import CardPage from './pages/CardPage';
// import Admin from './pages/Admin';
// import NotFound from './pages/NotFound';
// import PrivateRoute from './components/PrivateRoute';
// import Header from './components/Header';
// import Footer from './components/Footer';
// import PreviewAuth from './pages/PreviewAuth';
// import './App.css';

// function AppContent() {
//   const location = useLocation();
//   const isAdminPage = location.pathname === '/admin';
//   const isPreview = location.pathname.startsWith('/preview');
//   const { publishToProduction, revertAllDrafts } = useContext(CardsContext);

//   return (
//     <div className="App">
//       {!isAdminPage && <Header />}
      
//       <Routes>
//         {/* ===== БОЕВОЙ САЙТ ===== */}
//         <Route path="/" element={<Main isPreview={false} />} />
//         <Route path="/adventures" element={<Adventures isPreview={false} />} />
//         <Route path="/study" element={<Study isPreview={false} />} />
//         <Route path="/races" element={<Races isPreview={false} />} />
//         <Route path="/info" element={<Info isPreview={false} />} />
//         <Route path="/schedule" element={<Schedule isPreview={false} />} />
//         <Route path="/card/:cardId" element={<CardPage isPreview={false} />} />
        
//         {/* ===== СТРАНИЦА ВХОДА В ПРЕВЬЮ ===== */}
// <Route path="/preview-login" element={<PreviewAuth />} />

//         {/* ===== ПРЕВЬЮ (ТОЛЬКО ДЛЯ АДМИНОВ) ===== */}
//         {/*<Route 
//           path="/preview" 
//           element={
//             <PrivateRoute>
//               <Main isPreview={true} />
//             </PrivateRoute>
//           } 
//         />
//         <Route 
//           path="/preview/adventures" 
//           element={
//             <PrivateRoute>
//               <Adventures isPreview={true} />
//             </PrivateRoute>
//           } 
//         />
//         <Route 
//           path="/preview/study" 
//           element={
//             <PrivateRoute>
//               <Study isPreview={true} />
//             </PrivateRoute>
//           } 
//         />
//         <Route 
//           path="/preview/races" 
//           element={
//             <PrivateRoute>
//               <Races isPreview={true} />
//             </PrivateRoute>
//           } 
//         />
//         <Route 
//           path="/preview/info" 
//           element={
//             <PrivateRoute>
//               <Info isPreview={true} />
//             </PrivateRoute>
//           } 
//         />
//         <Route 
//           path="/preview/schedule" 
//           element={
//             <PrivateRoute>
//               <Schedule isPreview={true} />
//             </PrivateRoute>
//           } 
//         />
//         <Route 
//           path="/preview/card/:cardId" 
//           element={
//             <PrivateRoute>
//               <CardPage isPreview={true} />
//             </PrivateRoute>
//           }  
//         />*/}

//         <Route 
//   path="/preview" 
//   element={
//     <PrivateRoute>
//       <Main isPreview={true} />
//     </PrivateRoute>
//   } 
// />

//         {/* ===== АДМИНКА ===== */}
//         <Route 
//           path="/admin" 
//           element={
//             <PrivateRoute>
//               <Admin />
//             </PrivateRoute>
//           } 
//         />
        
//         <Route path="*" element={<NotFound />} />
//       </Routes>
      
//       {!isAdminPage && <Footer />}
      
//       {/* ПАНЕЛЬ ПРЕВЬЮ */}
//       {isPreview && (
//         <div style={{
//           position: 'fixed',
//           bottom: '20px',
//           left: '50%',
//           transform: 'translateX(-50%)',
//           zIndex: 9999,
//           background: 'rgba(0,0,0,0.9)',
//           color: 'white',
//           padding: '10px 20px',
//           borderRadius: '8px',
//           display: 'flex',
//           gap: '15px',
//           alignItems: 'center',
//           boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
//           backdropFilter: 'blur(10px)'
//         }}>
//           <span style={{ fontSize: '14px' }}>
//             🔍 Режим предпросмотра — так будет выглядеть сайт после публикации
//           </span>
//           <button
//             onClick={() => {
//               if (publishToProduction()) {
//                 window.location.href = '/';
//               }
//             }}
//             style={{
//               background: '#4CAF50',
//               color: 'white',
//               border: 'none',
//               padding: '8px 16px',
//               borderRadius: '4px',
//               cursor: 'pointer',
//               fontSize: '14px',
//               fontWeight: 'bold'
//             }}
//           >
//             🚀 Похуй в продакшен!
//           </button>
//           <button
//             onClick={() => {
//               if (window.confirm('Отменить все изменения?')) {
//                 if (revertAllDrafts()) {
//                   window.location.href = '/';
//                 }
//               }
//             }}
//             style={{
//               background: '#f44336',
//               color: 'white',
//               border: 'none',
//               padding: '8px 16px',
//               borderRadius: '4px',
//               cursor: 'pointer',
//               fontSize: '14px'
//             }}
//           >
//             ↩️ Отменить всё
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }

// function App() {
//   return (
//     <CardsProvider>
//       <Router>
//         <AppContent />
//       </Router>
//     </CardsProvider>
//   );
// }

// export default App;

import React, { useContext, useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { CardsProvider, CardsContext } from './context/CardsContext';
import { MediaProvider } from './context/MediaContext';
import { SiteContentProvider, SiteContentContext } from './context/SiteContentContext';
import { GeoProvider } from './context/GeoContext';
import Main from './pages/Main';
import Adventures from './pages/Adventures';
import Study from './pages/Study';
import Races from './pages/Races';
import Info from './pages/Info';
import Schedule from './pages/Schedule';
import CardPage from './pages/CardPage';
import YachtPage from './pages/YachtPage';
import InstructorPage from './pages/InstructorPage';
import FleetPage from './pages/FleetPage';
import TeamPage from './pages/TeamPage';
import FaqPage from './pages/FaqPage';
import PackingPage from './pages/PackingPage';
import IymcsPage from './pages/IymcsPage';
import PrivacyPage from './pages/PrivacyPage';
import PersonalDataPage from './pages/PersonalDataPage';
import PricingPage from './pages/PricingPage';
import NotFound from './pages/NotFound';
import PreviewAuth from './pages/PreviewAuth';
import PrivateRoute from './components/PrivateRoute';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import ScrollToTop from './components/ScrollToTop';
import ChangeSummaryModal from './components/ChangeSummaryModal';
import { preloadSmartCaptcha } from './hooks/useSmartCaptcha';
import './App.css';
import './styles/dark_theme.css';
import { ThemeProvider } from './context/ThemeContext';

// Админка вынесена в отдельный chunk (code splitting): она тянет тяжёлые
// tiptap-редактор и xlsx — посетителям сайта этот код не нужен и не грузится.
const Admin = React.lazy(() => import('./pages/Admin'));

function AppContent() {
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin';
  const isPreview = location.pathname.startsWith('/preview');

  // Предзагружаем скрипт SmartCaptcha сразу при заходе на сайт (не дожидаясь
  // открытия формы заявки/вопроса) — тогда проверка "я не робот" стартует мгновенно.
  useEffect(() => {
    if (!isAdminPage) preloadSmartCaptcha();
  }, [isAdminPage]);

  // Запрет индексации preview и admin страниц
  if (isPreview || isAdminPage) {
    let meta = document.querySelector('meta[name="robots"]');
    if (!meta) { meta = document.createElement('meta'); meta.name = 'robots'; document.head.appendChild(meta); }
    meta.content = 'noindex,nofollow';
  } else {
    const meta = document.querySelector('meta[name="robots"]');
    if (meta) meta.content = 'index,follow';
  }
  const { publishToProduction, revertAllDrafts, loading } = useContext(CardsContext);
  const { publishContent } = useContext(SiteContentContext);
  const [publishing, setPublishing] = useState(false);
  const [showPublishDiff, setShowPublishDiff] = useState(false);

  const doPublish = async () => {
    setPublishing(true);
    try {
      await publishContent();
      if (await publishToProduction()) {
        window.location.href = '/';
      } else {
        setPublishing(false);
      }
    } catch {
      alert('❌ Ошибка публикации контента');
      setPublishing(false);
    }
  };


  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', flexDirection: 'column', gap: 16, color: '#888' }}>
        <div style={{ fontSize: 32 }}>⛵</div>
        <div>Загрузка...</div>
      </div>
    );
  }

  return (
    <div className="App">
      <ScrollToTop />
      {!isAdminPage && <Header />}
      
      <Routes>
        {/* ===== БОЕВОЙ САЙТ ===== */}
        <Route path="/" element={<Main isPreview={false} />} />
        <Route path="/adventures" element={<Adventures isPreview={false} />} />
        <Route path="/study" element={<Study isPreview={false} />} />
        <Route path="/races" element={<Races isPreview={false} />} />
        <Route path="/info" element={<Info isPreview={false} />} />
        <Route path="/schedule" element={<Schedule isPreview={false} />} />
        <Route path="/card/:cardId" element={<CardPage isPreview={false} />} />
        <Route path="/study/:cardId" element={<CardPage isPreview={false} />} />
        <Route path="/adventures/:cardId" element={<CardPage isPreview={false} />} />
        <Route path="/races/:cardId" element={<CardPage isPreview={false} />} />
        <Route path="/news/:cardId" element={<CardPage isPreview={false} />} />
        <Route path="/yacht/:yachtId" element={<YachtPage />} />
        <Route path="/instructor/:instructorId" element={<InstructorPage />} />
        <Route path="/fleet" element={<FleetPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/packing" element={<PackingPage />} />
        <Route path="/iymcs" element={<IymcsPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/personal-data" element={<PersonalDataPage />} />

        {/* ===== СТРАНИЦА ВХОДА В ПРЕВЬЮ ===== */}
        <Route path="/preview-login" element={<PreviewAuth />} />
        
        {/* ===== ПРЕВЬЮ (только для авторизованных) ===== */}
        <Route 
          path="/preview" 
          element={
            <PrivateRoute>
              <Main isPreview={true} />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/preview/adventures" 
          element={
            <PrivateRoute>
              <Adventures isPreview={true} />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/preview/study" 
          element={
            <PrivateRoute>
              <Study isPreview={true} />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/preview/races" 
          element={
            <PrivateRoute>
              <Races isPreview={true} />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/preview/info" 
          element={
            <PrivateRoute>
              <Info isPreview={true} />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/preview/schedule" 
          element={
            <PrivateRoute>
              <Schedule isPreview={true} />
            </PrivateRoute>
          } 
        />
        <Route path="/preview/card/:cardId" element={<PrivateRoute><CardPage isPreview={true} /></PrivateRoute>} />
        <Route path="/preview/study/:cardId" element={<PrivateRoute><CardPage isPreview={true} /></PrivateRoute>} />
        <Route path="/preview/adventures/:cardId" element={<PrivateRoute><CardPage isPreview={true} /></PrivateRoute>} />
        <Route path="/preview/races/:cardId" element={<PrivateRoute><CardPage isPreview={true} /></PrivateRoute>} />
        <Route path="/preview/news/:cardId" element={<PrivateRoute><CardPage isPreview={true} /></PrivateRoute>} />
        <Route
          path="/preview/fleet"
          element={
            <PrivateRoute>
              <FleetPage isPreview={true} />
            </PrivateRoute>
          }
        />
        <Route
          path="/preview/team"
          element={
            <PrivateRoute>
              <TeamPage isPreview={true} />
            </PrivateRoute>
          }
        />
        <Route
          path="/preview/faq"
          element={
            <PrivateRoute>
              <FaqPage isPreview={true} />
            </PrivateRoute>
          }
        />
        <Route
          path="/preview/packing"
          element={
            <PrivateRoute>
              <PackingPage isPreview={true} />
            </PrivateRoute>
          }
        />
        <Route
          path="/preview/iymcs"
          element={
            <PrivateRoute>
              <IymcsPage isPreview={true} />
            </PrivateRoute>
          }
        />
        <Route
          path="/preview/pricing"
          element={
            <PrivateRoute>
              <PricingPage isPreview={true} />
            </PrivateRoute>
          }
        />
        <Route
          path="/preview/privacy"
          element={
            <PrivateRoute>
              <PrivacyPage isPreview={true} />
            </PrivateRoute>
          }
        />
        <Route
          path="/preview/yacht/:yachtId"
          element={
            <PrivateRoute>
              <YachtPage isPreview={true} />
            </PrivateRoute>
          }
        />
        <Route
          path="/preview/instructor/:instructorId"
          element={
            <PrivateRoute>
              <InstructorPage isPreview={true} />
            </PrivateRoute>
          }
        />

        {/* ===== АДМИНКА ===== */}
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <React.Suspense fallback={<div style={{ textAlign: 'center', padding: 60, color: '#888' }}>Загрузка админки...</div>}>
                <Admin />
              </React.Suspense>
            </PrivateRoute>
          }
        />
        
        <Route path="*" element={<NotFound />} />
      </Routes>
      
      {!isAdminPage && <Footer />}
      {!isAdminPage && <CookieBanner />}

      {/* ПАНЕЛЬ ПРЕВЬЮ (только в режиме превью) */}
      {isPreview && (
        <div style={{
          position: 'fixed',
          bottom: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 9999,
          background: 'rgba(0,0,0,0.9)',
          color: 'white',
          padding: '10px 20px',
          borderRadius: '8px',
          display: 'flex',
          gap: '15px',
          alignItems: 'center',
          boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
          backdropFilter: 'blur(10px)'
        }}>
          <span style={{ fontSize: '14px' }}>
            🔍 Режим предпросмотра — так будет выглядеть сайт после публикации
          </span>
          <button
            disabled={publishing}
            onClick={() => setShowPublishDiff(true)}
            style={{
              background: publishing ? '#888' : '#4CAF50',
              color: 'white',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '4px',
              cursor: publishing ? 'not-allowed' : 'pointer',
              fontSize: '14px',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            {publishing ? (
              <>
                <span style={{
                  display: 'inline-block',
                  width: '14px',
                  height: '14px',
                  border: '2px solid rgba(255,255,255,0.4)',
                  borderTopColor: 'white',
                  borderRadius: '50%',
                  animation: 'spin 0.7s linear infinite'
                }} />
                Публикуем...
              </>
            ) : '🚀 Похуй в продакшен!'}
          </button>
          <button
            onClick={() => {
              if (window.confirm('Отменить все изменения?')) {
                if (revertAllDrafts()) {
                  window.location.href = '/';
                }
              }
            }}
            style={{
              background: '#f44336',
              color: 'white',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            ↩️ Отменить всё
          </button>
        </div>
      )}

      {showPublishDiff && (
        <ChangeSummaryModal
          title="Изменения, которые попадут на боевой сайт"
          confirmLabel="🚀 Всё верно — опубликовать"
          onCancel={() => setShowPublishDiff(false)}
          onConfirm={() => { setShowPublishDiff(false); doPublish(); }}
        />
      )}


    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <MediaProvider>
        <GeoProvider>
          <CardsProvider>
            <Router>
              <SiteContentProvider>
                <AppContent />
              </SiteContentProvider>
            </Router>
          </CardsProvider>
        </GeoProvider>
      </MediaProvider>
    </ThemeProvider>
  );
}

export default App;